__turbopack_context__.v({
  "arrow": "style-module-scss-module__wpioPa__arrow",
  "card": "style-module-scss-module__wpioPa__card",
  "component": "style-module-scss-module__wpioPa__component",
  "slider": "style-module-scss-module__wpioPa__slider",
});
